import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {
    ActionCardImage,
    GraphicalActionCard,
    LinkWithAttribution,
} from '../../../../../../components';

export function CardiovascularDiseaseExercise(props) {
    const {currentStep, totalSteps} = props;

    const intl = useIntl();

    return (
        <GraphicalActionCard
            currentStep={currentStep}
            dataTestId={'exercise-CVD_US'}
            headerImage={ActionCardImage.EXERCISE}
            title={intl.formatMessage({id: 'reports.trait.lifestyleActions.exercise.title'})}
            totalSteps={totalSteps}
        >
            <p>
                <FormattedMessage
                    id={'reports.trait.lifestyleActions.exercise.description.one.CVD_US'}
                />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.lifestyleActions.exercise.description.two'} />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.lifestyleActions.exercise.description.three'} />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.lifestyleActions.exercise.description.four'} />
            </p>
            <ul>
                <li>
                    <FormattedMessage id={'reports.trait.lifestyleActions.exercise.item.one'} />
                </li>
                <li>
                    <FormattedMessage id={'reports.trait.lifestyleActions.exercise.item.two'} />
                </li>
                <li>
                    <FormattedMessage id={'reports.trait.lifestyleActions.exercise.item.three'} />
                </li>
            </ul>
            <p>
                <FormattedMessage id={'reports.trait.lifestyleActions.exercise.description.five'} />
            </p>
            <LinkWithAttribution
                attribution={intl.formatMessage({id: 'common.link.attribution.AHA'})}
                url={'https://www.heart.org/en/healthy-living/fitness/getting-active/no-time-for-exercise-here-are-7-easy-ways-to-move-more'}
            >
                <FormattedMessage id={'reports.trait.lifestyleActions.exercise.link.ways'} />
            </LinkWithAttribution>
            <LinkWithAttribution
                attribution={intl.formatMessage({id: 'common.link.attribution.AHA'})}
                url={'https://www.heart.org/en/healthy-living/fitness/getting-active/getting-started---tips-for-long-term-exercise-success'}
            >
                <FormattedMessage id={'reports.trait.lifestyleActions.exercise.link.tips'} />
            </LinkWithAttribution>
        </GraphicalActionCard>
    );
}
